//users information types:
export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST'
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS'
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE'

export const FETCH_LISTS_SUCCESS = 'FETCH_LISTS_SUCCESS'
export const FETCH_LISTS_REQUEST = 'FETCH_LISTS_REQUEST'
export const FETCH_LISTS_FAILURE = 'FETCH_LISTS_FAILURE'

export const FETCH_FAVORITES_REQUEST = 'FETCH_FAVORITES_REQUEST'
export const FETCH_FAVORITES_SUCCESS = 'FETCH_FAVORITES_SUCCESS'
export const FETCH_FAVORITES_FAILURE = 'FETCH_FAVORITES_FAILURE'

export const TOGGLE_USER_FROM_FAVORITES = 'TOGGLE_USER_FROM_FAVORITES'

export const MARK_MESSAGES_AS_READ = 'MARK_MESSAGES_AS_READ'

export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS'

export const SEARCH_USERS_REQUEST = 'SEARCH_USERS_REQUEST'
export const SEARCH_USERS_SUCCESS = 'SEARCH_USERS_SUCCESS'
export const SEARCH_USERS_SET_CENTERS = 'SEARCH_USERS_SET_CENTERS'
export const SEARCH_USERS_FAILURE = 'SEARCH_USERS_FAILURE'
export const SEARCH_USERS_UPDATE_USER = 'SEARCH_USERS_UPDATE_USER'
export const UPDATE_USERS_SEARCH_ORDER = 'UPDATE_USERS_SEARCH_ORDER'

export const FETCH_USERS_QUERY_REQUEST = 'FETCH_USERS_QUERY_REQUEST'
export const FETCH_USERS_QUERY_SUCCESS = 'FETCH_USERS_QUERY_SUCCESS'
export const FETCH_USERS_QUERY_FAILURE = 'FETCH_USERS_QUERY_FAILURE'

//dashboard power user:
export const LOGIN_POUSER_REQUEST = 'LOGIN_POUSER_REQUEST'
export const LOGIN_POUSER_SUCCESS = 'LOGIN_POUSER_SUCCESS'
export const LOGIN_POUSER_FAILURE = 'LOGIN_POUSER_FAILURE'

export const FETCH_POUSER_REQUEST = 'FETCH_POUSER_REQUEST'
export const FETCH_POUSER_SUCCESS = 'FETCH_POUSER_SUCCESS'
export const FETCH_POUSER_FAILURE = 'FETCH_POUSER_FAILURE'

export const UPDATE_POUSER_REQUEST = 'UPDATE_POUSER_REQUEST'
export const UPDATE_POUSER_SUCCESS = 'UPDATE_POUSER_SUCCESS'
export const UPDATE_POUSER_FAILURE = 'UPDATE_POUSER_FAILURE'

export const FETCH_WEBUSERS_REQUEST = 'FETCH_WEBUSERS_REQUEST'
export const FETCH_WEBUSERS_SUCCESS = 'FETCH_WEBUSERS_SUCCESS'
export const FETCH_WEBUSERS_FAILURE = 'FETCH_WEBUSERS_FAILURE'

//plugins payment types:
export const GENERATE_BILL_REQUEST = 'GENERATE_BILL_REQUEST'
export const GENERATE_BILL_SUCCESS = 'GENERATE_BILL_SUCCESS'
export const GENERATE_BILL_FAILURE = 'GENERATE_BILL_FAILURE'

export const SEND_LOCATOR_MESSAGE_REQUEST = 'SEND_LOCATOR_MESSAGE_REQUEST'
export const SEND_LOCATOR_MESSAGE_SUCCESS = 'SEND_LOCATOR_MESSAGE_SUCCESS'
export const SEND_LOCATOR_MESSAGE_FAILURE = 'SEND_LOCATOR_MESSAGE_FAILURE'

export const RESET_PAYMENT_PLUGIN = 'RESET_PAYMENT_PLUGIN'

//plugins search
export const SEARCH_QUERY_REQUEST = 'SEARCH_QUERY_REQUEST'
export const SEARCH_QUERY_SUCCESS = 'SEARCH_QUERY_SUCCESS'
export const SEARCH_QUERY_FAILURE = 'SEARCH_QUERY_FAILURE'

export const POLL_RESULTS_REQUEST = 'POLL_RESULTS_REQUEST'
export const POLL_RESULTS_SUCCESS = 'POLL_RESULTS_SUCCESS'
export const POLL_RESULTS_FAILURE = 'POLL_RESULTS_FAILURE'

export const SEND_RESULTS_REQUEST = 'SEND_RESULTS_REQUEST'
export const SEND_RESULTS_SUCCESS = 'SEND_RESULTS_SUCCESS'
export const SEND_RESULTS_FAILURE = 'SEND_RESULTS_FAILURE'

//management
export const FETCH_COMPANY_REQUEST = 'FETCH_COMPANY_REQUEST'
export const FETCH_COMPANY_SUCCESS = 'FETCH_COMPANY_SUCCESS'
export const FETCH_COMPANY_FAILURE = 'FETCH_COMPANY_FAILURE'

export const FETCH_COMPANIES_REQUEST = 'FETCH_COMPANIES_REQUEST'
export const FETCH_COMPANIES_SUCCESS = 'FETCH_COMPANIES_SUCCESS'
export const FETCH_COMPANIES_FAILURE = 'FETCH_COMPANIES_FAILURE'

export const FETCH_MANAGEMENT_USERS_REQUEST = 'FETCH_MANAGEMENT_USERS_REQUEST'
export const FETCH_MANAGEMENT_USERS_SUCCESS = 'FETCH_MANAGEMENT_USERS_SUCCESS'
export const FETCH_MANAGEMENT_USERS_FAILURE = 'FETCH_MANAGEMENT_USERS_FAILURE'

export const ADD_MANAGEMENT_USER_REQUEST = 'ADD_MANAGEMENT_USER_REQUEST'
export const ADD_MANAGEMENT_USER_SUCCESS = 'ADD_MANAGEMENT_USER_SUCCESS'
export const ADD_MANAGEMENT_USER_FAILURE = 'ADD_MANAGEMENT_USER_FAILURE'

export const UPDATE_MANAGEMENT_USER_REQUEST = 'UPDATE_MANAGEMENT_USER_REQUEST'
export const UPDATE_MANAGEMENT_USER_SUCCESS = 'UPDATE_MANAGEMENT_USER_SUCCESS'
export const UPDATE_MANAGEMENT_USER_FAILURE = 'UPDATE_MANAGEMENT_USER_FAILURE'

export const DELETE_MANAGEMENT_USER_REQUEST = 'DELETE_MANAGEMENT_USER_REQUEST'
export const DELETE_MANAGEMENT_USER_SUCCESS = 'DELETE_MANAGEMENT_USER_SUCCESS'
export const DELETE_MANAGEMENT_USER_FAILURE = 'DELETE_MANAGEMENT_USER_FAILURE'

export const FETCH_ROLES_REQUEST = 'FETCH_ROLES_REQUEST'
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS'
export const FETCH_ROLES_FAILURE = 'FETCH_ROLES_FAILURE'

export const FETCH_ASSIGNATIONS_REQUEST = 'FETCH_ASSIGNATIONS_REQUEST'
export const FETCH_ASSIGNATIONS_SUCCESS = 'FETCH_ASSIGNATIONS_SUCCESS'
export const FETCH_ASSIGNATIONS_FAILURE = 'FETCH_ASSIGNATIONS_FAILURE'

export const ADD_ASSIGNATIONS_REQUEST = 'ADD_ASSIGNATIONS_REQUEST'
export const ADD_ASSIGNATIONS_SUCCESS = 'ADD_ASSIGNATIONS_SUCCESS'
export const ADD_ASSIGNATIONS_FAILURE = 'ADD_ASSIGNATIONS_FAILURE'

export const DELETE_ASSIGNATIONS_REQUEST = 'DELETE_ASSIGNATIONS_REQUEST'
export const DELETE_ASSIGNATIONS_SUCCESS = 'DELETE_ASSIGNATIONS_SUCCESS'
export const DELETE_ASSIGNATIONS_FAILURE = 'DELETE_ASSIGNATIONS_FAILURE'

// cv_search
export const RESET_USER_SEARCH_FILTERS = 'RESET_USER_SEARCH_FILTERS'
export const UPDATE_USERS_SEARCH_FILTERS = 'UPDATE_USERS_SEARCH_FILTERS'
export const SET_USERS_SEARCH_CHECKS = 'SET_USERS_SEARCH_CHECKS'
export const TOGGLE_USERS_SEARCH_IS_ALL_CHECKS = 'TOGGLE_USERS_SEARCH_IS_ALL_CHECKS'
export const SET_USERS_COLUMNS_VIEW = 'SET_USERS_COLUMNS_VIEW'

//cv_usersLists
export const FETCH_USERS_LISTS_REQUEST = 'FETCH_USERS_LISTS_REQUEST'
export const FETCH_USERS_LISTS_SUCCESS = 'FETCH_USERS_LISTS_SUCCESS'
export const FETCH_USERS_LISTS_FAILURE = 'FETCH_USERS_LISTS_FAILURE'
